<template>
  <div>
    <PageHeader :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("firstName")
              }}</label>
              <input
                id="firstName"
                v-model="form.firstName"
                name="title"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("lastName")
              }}</label>
              <input
                id="lastName"
                v-model="form.lastName"
                name="title"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label"
                >{{ $t("email") }}
              </label>
              <input
                id="email"
                v-model="form.email"
                name="title"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("city")
              }}</label>
              <input
                id="title"
                v-model="form.city"
                name="title"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("street")
              }}</label>
              <input
                id="street"
                v-model="form.street"
                name="street"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("streetNumber")
              }}</label>
              <input
                id="streetNumber"
                v-model="form.streetNumber"
                name="streetNumber"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("zip")
              }}</label>
              <input
                id="zip"
                v-model="form.zip"
                name="zip"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("mobile")
              }}</label>
              <input
                id="mobile"
                v-model="form.mobile"
                name="mobile"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("phone")
              }}</label>
              <input
                id="phoneNo"
                v-model="form.phoneNo"
                name="phoneNo"
                class="form-control"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="input-label form-label"
                >{{ $t("contactLanguage") }}
              </label>
              <select
                class="form-control"
                v-model="form.contactLanguage"
                disabled
              >
                <option
                  v-for="language in languages"
                  :value="language.code"
                  :key="language.code"
                >
                  {{ language.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("roles")
              }}</label>
              <multiselect
                v-model="form.roles"
                label="title"
                :multiple="true"
                track-by="id"
                :options="roles"
                selectLabel=""
                deselectLabel=""
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("company")
              }}</label>
              <MultiSelectInput
                v-model="form.company_id"
                :options="customers"
                :query="{ isMultiSelect: true }"
                label="companyName"
                trackBy="id"
                :key="form.company_id"
                moduleName="customers"
                :multiple="false"
                :isDisabled="true"
                ><template #option="{ props }">
                  <div>
                    <p>
                      {{ props.option.companyNumber }} -
                      {{ props.option.companyName }}
                    </p>
                  </div>
                </template>
              </MultiSelectInput>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="input-label form-label" for="cars">{{
                $t("types")
              }}</label>
              <multiselect
                v-model="form.types"
                :multiple="true"
                :options="types"
                selectLabel=""
                deselectLabel=""
                :disabled="true"
              />
            </div>
          </div>
        </div>
         <div class="row">
           <div class="col-md-4">
             <div class="form-group">
               <label class="input-label form-label" for="active">{{
                 $t("active")
               }}</label>
               <input
                 id="active"
                 class="form-check-input-custom ml-2"
                 v-model="form.status"
                 type="checkbox"
                 disabled
               />
             </div>
           </div>
           <div v-if="lastLogin && lastLogin.date" class="col-md-4">
             <div class="form-group mt-1">
               <label class="input-label form-label" for="active">{{
                 $t("lastLogin")
               }}</label>

               <p>{{ formatLastLoginDate(lastLogin.date) }}</p>
             </div>
           </div>
         </div>
       </div>
     </div>
     
     <!-- Last Login Table -->
     <!-- <div v-if="lastLogin" class="card mt-3">
       <div class="card-body">
         <h5 class="card-title text-primary">{{ $t("lastLogin") }}</h5>
         <div class="table-responsive">
           <table class="table table-bordered table-hover">
             <tbody>
               <tr>
                 <td class="font-weight-bold text-dark">{{ $t("date") }}</td>
                 <td class="text-dark">{{ formatLastLoginDate(lastLogin.date) }}</td>
               </tr>
               <tr>
                 <td class="font-weight-bold text-dark">{{ $t("timezone") }}</td>
                 <td class="text-dark">{{ lastLogin.timezone }}</td>
               </tr>
               <tr>
                 <td class="font-weight-bold text-dark">{{ $t("timezoneType") }}</td>
                 <td class="text-dark">{{ lastLogin.timezone_type }}</td>
               </tr>
             </tbody>
           </table>
         </div>
       </div>
     </div> -->
   </div>
 </template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeader,
    Multiselect,
    MultiSelectInput,
  },
  watch: {
    "form.company_id": {
      handler(newCompany) {
        if (newCompany && newCompany.preferredContactLanguage && (!this.form.contactLanguage || this.form.contactLanguage === "")) {
          this.form.contactLanguage = this.mapLanguageToCode(newCompany.preferredContactLanguage);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
       form: {
         firstName: "",
         lastName: "",
         email: "",
         city: "",
         street: "",
         streetNumber: "",
         zip: "",
         mobile: "",
         phoneNo: "",
         roles: [],
         types: [],
         company_id: "",
         status: true,
         contactLanguage: "",
        },
        lastLogin: null,
      types: ["customer_employee", "employee", "partner"],
      languages: [
        { code: "en", label: "English" },
        { code: "de", label: "German" },
        { code: "fr", label: "French" },
        { code: "es", label: "Spanish" },
        { code: "tr", label: "Turkish" },
      ],
    };
  },
  computed: {
    ...mapGetters("roles", ["roles"]),
    ...mapGetters("customers", ["customers"]),
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("users"),
          to: "/users",
        },
        {
          text: this.$t("show"),
          active: true,
        },
      ];
    },
  },
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("roles/list", {
        limit_start: 0,
        limit_count: 100,
      });
      await this.$store.dispatch("customers/list", { isMultiSelect: true });
      this.refresh();
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
   methods: {
    mapLanguageToCode(languageName) {
      const languageMap = {
        'English': 'en',
        'French': 'fr',
        'German': 'de',
        'Spanish': 'es',
        'Turkish': 'tr'
      };
      return languageMap[languageName] || '';
    },
    formatLastLoginDate(dateString) {
      if (!dateString || dateString === null || dateString === undefined) return '';
      try {
        // Parse the UTC date string and convert to local time
        const date = new Date(dateString + ' UTC');
        return date.toLocaleString();
      } catch (error) {
        return dateString;
      }
    },
     async refresh() {
      try {
        this.$store.commit("showLoader", true);
        this.$store
          .dispatch("users/show", {
            id: this.$route.params.id,
          })
          .then(async (res) => {
            if (res.message_type === "error") {
              return;
            } else {
              var response = res?.data;
              this.form.street = response.street;
              this.form.streetNumber = response.street_number;
              this.form.zip = response.zip;
              this.form.firstName = response.first_name;
              this.form.lastName = response.last_name;
              this.form.company_id = response.company_id;
              this.form.email = response.email;
              this.form.city = response.city;
              this.form.phoneNo = response.phone;
               this.form.types = response.types;
               this.form.contactLanguage = response.contact_language || "";
               this.form.status = response.status !== undefined ? response.status === 1 : true;
               this.lastLogin = response.last_login || null;
              this.form.types = Object.keys(this.form.types).filter(
                (type) => this.form.types[type] == 1
              );
              this.form.roles = response.roles
                .map((roleId) => {
                  return {
                    ...(this.roles.find((role) => role.id == roleId) ?? {}),
                  };
                })
                .filter((role) => role.id);

              let company =
                this.customers?.data?.find(
                  (company) => company.id === this.form.company_id
                ) ?? "";
              if (!company && this.form.company_id) {
                let res = await this.$store.dispatch(
                  "customers/show",
                  this.form.company_id
                );
                company = res?.data?.modelData ?? "";
              }
              this.form.company_id = company;
              
              if (company && company.preferredContactLanguage && (!this.form.contactLanguage || this.form.contactLanguage === "")) {
                this.form.contactLanguage = this.mapLanguageToCode(company.preferredContactLanguage);
              }
            }
          });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
